import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AdminDashboard from "./components/Admin/AdminDashboard";
import ManageCoupons from "./components/Admin/Coupons/ManageCoupons";
import AddCoupon from "./components/Admin/Coupons/AddCoupon";
import Login from "./components/Users/Forms/Login";
import AddProduct from "./components/Admin/Products/AddProduct";
import RegisterForm from "./components/Users/Forms/RegisterForm";
import HomePage from "./components/HomePage/HomePage";
import Navbar from "./components/Navbar/Navbar";
import OrderHistory from "./components/Admin/Orders/ManageOrders";
import OrderPayment from "./components/Users/Products/OrderPayment";
import ManageCategories from "./components/Admin/Categories/ManageCategories";
import UpdateProduct from "./components/Admin/Products/UpdateProduct";
import ManageStocks from "./components/Admin/Products/ManageStocks";
import CategoryToAdd from "./components/Admin/Categories/CategoryToAdd";
import AddCategory from "./components/Admin/Categories/AddCategory";
import AddBrand from "./components/Admin/Categories/AddBrand";
import AddColor from "./components/Admin/Categories/AddColor";
import AllCategories from "./components/HomePage/AllCategories";
import UpdateCoupon from "./components/Admin/Coupons/UpdateCoupon";
import Product from "./components/Users/Products/Product";
import ShoppingCart from "./components/Users/Products/ShoppingCart";
import ProductsFilters from "./components/Users/Products/ProductsFilters";
import CustomerProfile from "./components/Users/Profile/CustomerProfile";
import AddReview from "./components/Users/Reviews/AddReview";
import UpdateCategory from "./components/Admin/Categories/UpdateCategory";
import OrdersList from "./components/Admin/Orders/OdersList";
import ManageOrders from "./components/Admin/Orders/ManageOrders";
import Customers from "./components/Admin/Orders/Customers";
import BrandsList from "./components/Admin/Categories/BrandsList";
import AuthRoute from "./components/AuthRoute/AuthRoute";
import AdminRoutes from "./components/AuthRoute/AdminRoutes";
import ThanksForOrdering from "./components/Users/Products/ThanksForOrdering";
import ProductUpdate from "./components/Admin/Products/ProuductUpdate";
import UpdateOrders from "./components/Admin/Orders/UpdateOrders";
import ColorsList from "./components/Admin/Categories/ColorsList";
import { useSelector } from "react-redux";
import Import from "./components/Import/Import";
import Products from "./components/Products/Products";
import Validations from "./components/SmartPipes/Validations"
import Destinations from "./components/SmartPipes/Destinations";
import GDSN from "./components/SmartPipes/gdsn";
import Connections from "./components/SmartPipes/Connections";
import Support from "./components/Support/Support";
import ImportDocument from "./components/Import/ImportDocument";
import ViewExportedFiles from "./components/ViewExported/ViewExportedFiles"
import ImportLoc from "./components/Import/ImportLoc";
import ImportDocumentLoc from "./components/Import/ImportDocumentLoc";
import ImportDocumentGLN from "./components/Import/ImportDocumentGLN";
import ImportGLN from "./components/Import/ImportGLN";
import GtinSearch from "./components/Search/GtinSearch";
import ImportOCR from "./components/Import/ImportOCR";
import GlnSearch from "./components/Search/GlnSearch";
import SearchDataHub from "./components/Search/SearchDataHub";
import Jobs from "./components/Jobs/Jobs";
import Reports from "./components/Reports/Reports";
import DashboardAnalytics from './components/Charts/DashboardAnalytics';
import ProductAnalytics from './components/Charts/ProductAnalytics';
import PublishingAnalytics from './components/Charts/PublishingAnalytics';
import CustomFieldManager from './components/CustomFields/CustomFieldManager';
import SchemaUpload from './components/Schema/SchemaUpload';
import PublishingReports from "./components/PublishingReports/PublishingReports";
import FieldListManager from './components/FieldLists/FieldListManager';
import Tutorials from './components/Tutorials/Tutorials';
import AIFieldLogicManager from './components/AIFieldLogic/AIFieldLogicManager';
import CountryOfOriginTest from './components/Test/CountryOfOriginTest';
import DynamicFormTest from './components/Test/DynamicFormTest';
import SimpleFieldTest from './components/Test/SimpleFieldTest';
import FieldNameTest from './components/Test/FieldNameTest';
import CleanupTest from './components/Test/CleanupTest';

const App = () => {
  const { userInfo } = useSelector((state) => state?.users?.userAuth);

  return (
    <BrowserRouter>
      {userInfo && <Navbar />}
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<RegisterForm />} />

        {/* Protected routes */}
        <Route
          path="/*"
          element={
            <AuthRoute>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/products" element={<Products />} />
                <Route path="/import" element={<Import />} />
                <Route path="/import_gln" element={<ImportGLN />} />
                <Route path="/import_loc" element={<ImportLoc />} />
                <Route path="/import_ocr" element={<ImportOCR />} />
                <Route path="/jobs" element={<Jobs />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/import_document" element={<ImportDocument />} />
                <Route
                  path="/import_document_gln"
                  element={<ImportDocumentGLN />}
                />
                <Route
                  path="/import_document_loc"
                  element={<ImportDocumentLoc />}
                />
                <Route path="/support" element={<Support />} />
                <Route path="/gtin_search" element={<GtinSearch />} />
                <Route path="/gln_search" element={<GlnSearch />} />
                <Route path="/search-data-hub" element={<SearchDataHub />} />
                <Route path="/destinations" element={<Destinations />} />
                <Route path="/connections" element={<Connections />} />
                <Route path="/validations" element={<Validations />} />
                <Route path="/s3" element={<ViewExportedFiles />} />
                <Route path="/gdsn" element={<GDSN />} />
                <Route path="/products-filters" element={<ProductsFilters />} />
                <Route path="/products/:id" element={<Product />} />
                <Route path="/all-categories" element={<AllCategories />} />
                <Route path="/success" element={<ThanksForOrdering />} />
                <Route path="/shopping-cart" element={<ShoppingCart />} />
                <Route path="/order-payment" element={<OrderPayment />} />
                <Route path="/customer-profile" element={<CustomerProfile />} />
                <Route path="/add-review/:id" element={<AddReview />} />
                <Route path="/analytics/dashboard" element={<DashboardAnalytics />} />
                <Route path="/analytics/products" element={<ProductAnalytics />} />
                <Route path="/analytics/publishing" element={<PublishingAnalytics />} />
                <Route path="/custom-fields" element={<CustomFieldManager />} />
                <Route path="/schema/upload" element={<SchemaUpload />} />
                <Route path="/publishing-reports" element={<PublishingReports />} />
                <Route path="/field-lists" element={<FieldListManager />} />
                <Route path="/ai-field-logic" element={<AIFieldLogicManager />} />
                <Route path="/tutorials" element={<Tutorials />} />
                <Route path="/test/country-of-origin" element={<CountryOfOriginTest />} />
                <Route path="/test/dynamic-form" element={<DynamicFormTest />} />
                <Route path="/test/simple-field" element={<SimpleFieldTest />} />
                <Route path="/test/field-name" element={<FieldNameTest />} />
                <Route path="/test/cleanup" element={<CleanupTest />} />

                {/* Admin routes */}
                <Route
                  path="admin/*"
                  element={
                    <AdminRoutes>
                      <Routes>
                        <Route path="" element={<AdminDashboard />} />
                        <Route path="add-product" element={<AddProduct />} />
                        <Route
                          path="manage-products"
                          element={<ManageStocks />}
                        />
                        <Route
                          path="products/edit/:id"
                          element={<ProductUpdate />}
                        />
                        <Route path="add-coupon" element={<AddCoupon />} />
                        <Route
                          path="manage-coupon"
                          element={<ManageCoupons />}
                        />
                        <Route
                          path="manage-coupon/edit/:code"
                          element={<UpdateCoupon />}
                        />
                        <Route
                          path="category-to-add"
                          element={<CategoryToAdd />}
                        />
                        <Route path="add-category" element={<AddCategory />} />
                        <Route
                          path="manage-category"
                          element={<ManageCategories />}
                        />
                        <Route
                          path="edit-category/:id"
                          element={<UpdateCategory />}
                        />
                        <Route path="add-brand" element={<AddBrand />} />
                        <Route path="all-brands" element={<BrandsList />} />
                        <Route path="add-color" element={<AddColor />} />
                        <Route path="all-colors" element={<ColorsList />} />
                        <Route
                          path="manage-orders"
                          element={<ManageOrders />}
                        />
                        <Route path="orders/:id" element={<UpdateOrders />} />
                        <Route path="customers" element={<Customers />} />
                      </Routes>
                    </AdminRoutes>
                  }
                />
              </Routes>
            </AuthRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
